

















































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { wirelessDataTooltip } from '../report-constants';
import _ from 'lodash';

const cssPrefix = 'sw-firewall-reports';

@Component({
  components: {
    SwCheckbox,
    SwIcon,
  },
  directives: {
    tooltip,
  },
})

export default class SwFirewallReports extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ type: Boolean, required: true, default: false })
  isClicked: boolean;

  @Prop({ type: Object, required: false })
  editReportData: any;

  @Prop({ type: Boolean, required: true, default: false })
  isModalClose: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  isReportEdit: boolean;

  @Prop({ type: Boolean, required: false, default: true })
  isClosedEdit: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  isSelectAll: boolean;

  displayDataTooltip: string[] = wirelessDataTooltip;

  dataset = [
    {
      actualName: this.$t('spog.unifiedInsights.wirelessReportTooltips.actName1')
      .toString(),
      requestName: 'summary',
      includes: false,
    },
    {
      actualName: this.$t('spog.unifiedInsights.wirelessReportTooltips.actName2')
      .toString(),
      requestName: 'inventory',
      includes: false,
    },
    {
      actualName: this.$t('spog.unifiedInsights.wirelessReportTooltips.actName3')
      .toString(),
      requestName: 'recommend',
      includes: false,
    },
    {
      actualName: this.$t('spog.unifiedInsights.wirelessReportTooltips.actName4')
      .toString(),
      requestName: 'security',
      includes: false,
    },
    {
      actualName: this.$t('spog.unifiedInsights.wirelessReportTooltips.actName5')
      .toString(),
      requestName: 'statistics',
      includes: false,
    },
    {
      actualName: this.$t('spog.unifiedInsights.wirelessReportTooltips.actName6')
      .toString(),
      requestName: 'topology',
      includes: false,
    },
  ];
  enableFlag:boolean = false;

  /**
    @desc This function will select/deselect all report content when click on select all
  */
  private selectReportContent(isSelectAll:boolean) {
    this.dataset.map((entry: { actualName: string; requestName: string; includes: boolean }) => {
      entry.includes = isSelectAll;
    });
  }

  /**
    @desc This function will check selectAll checkbox to select/deselect
  */
  @Watch('isSelectAll')
  selectAllContent() {
    if (this.isSelectAll) {
      this.selectReportContent(this.isSelectAll);
    }else if (!this.enableFlag) {
      this.selectReportContent(this.isSelectAll);
    }
  }

  @Watch('isReportEdit', { immediate: true })
  onChangeEditReportData() {
    this.dataset.map((entry: { actualName: string; requestName: string; includes: boolean }) => {
      entry.includes = false;
    });
    const wnmScheduleReportData = this.editReportData && this.editReportData.hasOwnProperty('wnmScheduleReportData') &&
      this.editReportData.wnmScheduleReportData || {};
    if (wnmScheduleReportData && !_.isEmpty(wnmScheduleReportData) && this.isReportEdit) {
      if (wnmScheduleReportData) {
        this.dataset.map((entry: { actualName: string; requestName: string; includes: boolean }) => {
          entry.includes = wnmScheduleReportData[entry.requestName] === true ? true : false;
        });
      }
    }
  }

  @Watch('dataset', { deep:true })
  checkSelectAllOption() {
    let selectedValueCount = 0;
    this.dataset.map((entry: { actualName: string; requestName: string; includes: boolean }) => {
      entry.includes && (selectedValueCount += 1);
    });
    if (selectedValueCount === 6) {
      this.$emit('selectAll', true);
      this.enableFlag = false;
    } else {
      this.$emit('selectAll', false);
      this.enableFlag = true;
    }
  }

  /**
    @desc This function will call when the user clicks on the save button
  */
  @Watch('isClicked')
  prepareDataset() {
    const postData: any = {};
    this.dataset.map((entry: any) => {
      postData[entry.requestName] = entry.includes;
    });
    this.dataset.map((entry: { actualName: string; requestName: string; includes: boolean }) => {
      entry.includes = false;
    });
    this.$emit('receivedData', postData);
  }

  /**
    @desc This function will call when the user opens the report-modal
  */
  // @Watch('isModalClose')
  // setDefaultValue() {
  //   this.dataset.map((entry: any) => {
  //     entry.includes = false;
  //   });
  // }

  get getDataset() {
    return this.dataset;
  }

  get getEditReportData() {
    return this.editReportData;
  }
}
